import { render, staticRenderFns } from "./FilterDeliveryShipper.vue?vue&type=template&id=61a7fce0"
import script from "./FilterDeliveryShipper.vue?vue&type=script&lang=ts"
export * from "./FilterDeliveryShipper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports